import { render, staticRenderFns } from "./CollegePurchaseDepartmentHod.vue?vue&type=template&id=475d249f"
import script from "./CollegePurchaseDepartmentHod.vue?vue&type=script&lang=js"
export * from "./CollegePurchaseDepartmentHod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports